import styled from "styled-components/macro";

export const Container = styled.div`
  width: 100%;
  .characters-card {
    position: relative;
  }
  .characters-card,
  .character-card-footer {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: none;
    background: var(--simplified-sb-background);
    border-radius: 20px;

    .secondary {
      display: flex;
      align-items: center;
      gap: 0px;
      flex-direction: row;
      svg {
        width: 22px;
        height: 22px;
        margin-right: 4px;
        path {
          fill: var(--primary-cta);
        }
      }
    }
    .tertiary {
      svg {
        path {
          fill: var(--grey-1);
        }
      }
      &.customize {
        svg {
          width: 18px;
          height: 18px;
          margin-right: 4px;
        }
      }
      .icon-wrapper {
        height: 40px;
        width: 40px;
      }
      &:hover {
        .text-button-inner,
        .icon-wrapper {
          background-color: var(--menu-color-active) !important;
        }
      }
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 16px 20px 0;
      width: calc(100% - 30px);
      margin: 0px;
      .help {
        line-height: 21px;
        border-radius: 25px;
        height: 21px;
        width: 21px;
        position: relative;
        color: var(--menu-color-fullscreen);
        display: block;
        padding: 0px;
        font-weight: bold;
        font-size: 17px;
        text-align: center;
        background: var(--grey-2);
      }

      .left-side {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 0px;
        flex-shrink: 1;

        .title-lockup {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 2px;

          .chevron-wrapper {
            display: flex;
            align-items: center;
          }

          .collapse-chevron {
            cursor: pointer;
            width: 20px;
            height: 20px;
            transition: transform 0.2s ease;

            path {
              fill: var(--grey-2);
            }
          }

          .rotated-chevron {
            transform: rotate(-90deg);
          }

          svg {
            width: 32px;
            height: 32px;
            margin-right: 2px;
            path {
              fill: var(--grey-0);
            }
          }
        }
        .FYI {
          // At small widths, we hide the FYI so that it doesn't overlap with the buttons
          opacity: ${(props) => (props.$showFullButtonText ? 1 : 0)};
          color: var(--grey-1);
          font-weight: 500;
          margin-bottom: 0px;
          margin-left: 4px;
        }

        h2 {
          margin-bottom: 0px !important;
          font-weight: 500;
          font-size: 20px !important;
          margin-left: -4px;
        }
      }
      .right-side {
        display: flex;
        align-items: center;
        flex-direction: row;
        right: 16px; // set to respect padding of the parent container
        gap: 10px;
        margin: 0px;
        flex-shrink: 0;
        z-index: 1;
        &.show-cast {
          align-items: baseline;
        }
        .role-select {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          min-width: 220px;
          label {
            font-size: 12px;
            font-weight: 500;
            color: var(--grey-1);
          }
          .role-selector {
            width: 100%;
          }
        }

        button {
          padding: 7px !important;
          border-radius: 10px !important;
          margin-top: 0px !important;
          display: flex;
          flex-direction: row;
          align-items: center;

          &.secondary {
            padding: 5px 12px 5px 7px !important;
            svg {
              path {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }
        }
      }
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: calc(100% - 32px);
      padding: 14px 16px 14px 16px;
      border-top: 1.5px solid var(--menu-color-active);
      background-color: var(--menu-color-tinted);
      border-radius: 0px 0px 20px 20px;
      .left-side {
        display: flex;
        align-items: center;
        gap: 4px;
        min-width: 200px;
        flex-shrink: 1;
        position: relative;

        .menu-item.import {
          .icon {
            path {
              stroke: var(--grey-0);
            }
          }
        }
      }
      .right-side {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
        button {
          padding: 9px 14px !important;
          border-radius: 10px !important;
          margin-top: 0px !important;

          &.secondary {
            padding: 5px 12px 5px 7px !important;
            svg {
              path {
                fill: var(--primary-cta-high-contrast);
              }
            }
          }
        }
      }
    }
  }

  .primary {
    gap: 4px;
    svg {
      path {
        fill: var(--cta-text-color);
      }
    }
  }

  .generating-cast-container {
    background-color: var(--menu-color);
    border-radius: 10px;
    z-index: 1001;
  }

  .generateCastContainer {
    color: var(--grey-0);
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
    p {
      font-size: 18px;
      color: var(--grey-0);
    }

    button {
      display: flex;
      align-items: center;

      p {
        color: var(--cta-text-color);
      }
      svg {
        width: 22px;
        height: 22px;
      }
      p {
        font-size: 16px;
      }
    }

    .button-container {
      height: 63px;
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
      .svg-container {
        z-index: 1000;
        display: flex;
        gap: 15px;
        margin-bottom: -4px;
        justify-content: center;

        #icon-1 {
          transform: scale(120%) rotate(-10deg) translate(5px, 3px);
          path {
            fill: #38bdda;
          }
        }
        #icon-2 {
          transform: scale(180%) rotate(-5deg) translate(0px, -1px);
          path {
            fill: #ff8c22;
          }
        }
        #icon-3 {
          transform: scale(200%) rotate(0deg) translate(0px, -2px);
          path {
            fill: var(--primary-cta-high-contrast);
          }
        }
        #icon-4 {
          transform: scale(180%) rotate(5deg) translate(0px, -1px);
          path {
            fill: #ff5862;
          }
        }
        #icon-5 {
          transform: scale(120%) rotate(10deg) translate(-5px, 3px);
          path {
            fill: #2cb915;
          }
        }
      }
      button {
        position: relative;
        bottom: 0px;
        z-index: 10000 !important;
        margin-top: 0px !important;
        border-radius: 10px !important;
      }
    }

    .button-container:hover .svg-container #icon-1 {
      animation: wiggle1 0.8s ease-in-out 0.3s;
    }
    .button-container:hover .svg-container #icon-5 {
      animation: wiggle5 0.8s ease-in-out 0.3s;
    }
    .button-container:hover .svg-container #icon-2 {
      animation: wiggle2 0.8s ease-in-out 0.15s;
    }
    .button-container:hover .svg-container #icon-4 {
      animation: wiggle4 0.8s ease-in-out 0.15s;
    }
    .button-container:hover .svg-container #icon-3 {
      animation: wiggle3 1s ease-in-out;
    }

    @keyframes wiggle1 {
      0% {
        transform: scale(120%) rotate(-10deg) translate(5px, 3px);
      }
      30% {
        transform: scale(120%) rotate(-10deg) translate(5px, -3px);
      }
      100% {
        transform: scale(120%) rotate(-10deg) translate(5px, 3px);
      }
    }
    @keyframes wiggle2 {
      0% {
        transform: scale(180%) rotate(-5deg) translate(0px, -1px);
      }
      30% {
        transform: scale(180%) rotate(-5deg) translate(0px, -7px);
      }
      100% {
        transform: scale(180%) rotate(-5deg) translate(0px, -1px);
      }
    }
    @keyframes wiggle3 {
      0% {
        transform: scale(200%) rotate(0deg) translate(0px, -2px);
      }
      30% {
        transform: scale(200%) rotate(0deg) translate(0px, -8px);
      }
      100% {
        transform: scale(200%) rotate(0deg) translate(0px, -2px);
      }
    }
    @keyframes wiggle4 {
      0% {
        transform: scale(180%) rotate(5deg) translate(0px, -1px);
      }
      30% {
        transform: scale(180%) rotate(5deg) translate(0px, -7px);
      }
      100% {
        transform: scale(180%) rotate(5deg) translate(0px, -1px);
      }
    }
    @keyframes wiggle5 {
      0% {
        transform: scale(120%) rotate(10deg) translate(-5px, 3px);
      }
      30% {
        transform: scale(120%) rotate(10deg) translate(-5px, -3px);
      }
      100% {
        transform: scale(120%) rotate(10deg) translate(-5px, 3px);
      }
    }
  }

  .guidance {
    position: absolute;
    right: 0;
    z-index: 11000;
    border-radius: 20px;
    background-color: var(--menu-color);
    margin-top: 10px;
    padding: 20px 18px;
    box-shadow: var(--drop-shadow-15-25);

    &.section-header-position {
      right: 16px;
      top: 63px;
    }

    textarea {
      width: 350px;
      min-height: 72px;
      padding: 6px 10px;
      border-radius: 10px;
      resize: none;
      font-size: 16px;
      box-sizing: border-box;
      border: 2px solid var(--grey-2);

      &:focus {
        border-color: var(--primary-cta);
      }
    }
    .role-select {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-bottom: 12px;
      width: min(100%, 220px);

      label {
        font-size: 12px;
        font-weight: 500;
        color: var(--grey-1);
      }

      .role-selector {
        width: 100%;
        min-width: 0;
      }
    }
    .guidanceButtons {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 10px;
      button {
        margin-top: 0px !important;
      }
    }
    .randomCharacterButton {
      border: none !important;
      background: none !important;
      color: var(--grey-0) !important;
      display: flex;
      align-items: center;
      .text-button-inner {
        padding-left: 8px;
      }
      svg {
        path {
          fill: var(--grey-0);
        }
      }
    }
    .goButton {
      display: flex;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;

      padding: 9px 14px !important;
      border-radius: 10px !important;

      .keyboard-shortcut {
        border: 2px solid rgba(255, 255, 255, 0.4);
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
      .keyboard-shortcut-container {
        display: flex;
        align-items: center;
        gap: 3px;
      }
    }
  }

  .character-card-footer {
    background-color: transparent;
    border-radius: 0;
    box-shadow: none;
    .header {
      padding: 0;
      width: 100%;

      .right-side {
        right: 0;
        z-index: auto;
      }
    }
  }

  .hoverable-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    button {
      padding: 7px 12px 7px 7px !important;
    }
  }
`;
